<template>
 <router-view></router-view>

</template>

<script>

import router from "@/router";
import {useAuthStore} from "@/state/modules/auth"

export default {
  name: 'App',
  components: {
  },
  mounted() {
    window.addEventListener("message", this.handleOAuthMessage)
  },
  beforeMount() {

  },
  beforeUnmount() {
    window.removeEventListener("message", this.handleOAuthMessage)
  },
  methods: {
    async handleOAuthMessage(event) {
      if (event.origin !== window.location.origin) return

      if (event.data?.type === "OAUTH_SUCCESS") {
        const authStore = useAuthStore()

        // Session / cookie is already set by backend
        await authStore.validate()

        this.isLoading = false
        router.push("/")
      }
    }
  }
}
</script>
<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
@import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>